export default function SystemScreenHeader({title, subtitle}) {
    // Used in screens to display top title and subtitle

    // BUILD
    return (
        <div className={"w-full flex flex-col justify-start items-start mt-[24px]"}>
            <h1 className="text-[22px] font-semibold">
                {title}
            </h1>
            <h2 className="text-[16px] font-medium text-greyLight7 whitespace-pre-line">
                {subtitle}
            </h2>
        </div>
    );
}